import { css } from '@emotion/react';

import X from '~/common/assets/images/xgaming.svg?react';
import Flex from '~/common/components/display/Flex';
import { ThemeMode } from '~/common/types/theme.type.ts';

import type { CSSProperties } from 'react';

interface Props {
  /** 테마 모드 */
  theme?: ThemeMode;
  height?: CSSProperties['height'];
}

function Logo({ theme = ThemeMode.LIGHT, height = '27px' }: Props) {
  return (
    <Flex css={[styles.logo(height), styles[theme]]} items="center" inline>
      <X />
    </Flex>
  );
}

const styles = {
  logo: (height: Props['height']) => css`
    svg {
      //width: 24px;
      aspect-ratio: 640 / 727;
      height: ${height};
    }
  `,

  [ThemeMode.LIGHT]: css`
    color: rgb(47, 48, 51);
  `,

  [ThemeMode.DARK]: css`
    color: rgba(255, 255, 255, 0.85);
  `,
};

export default Logo;
